export default "__VITE_ASSET__Bu10dgPY__"